import React from 'react'

const IconPencilTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z' />
      </svg>
   )
}
export default IconPencilTool
